module.exports = __webpack_public_path__ + "img/media.c646e4b4.svg";